export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-[#4A1C40] to-[#3A0C30] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo and Description */}
          <div>
            <img 
              src="https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/073974e5b6d6dc4e6a4e834d20c0beaf.jpeg"
              alt="BMC Advocacia"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-300 text-sm leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Advocacia trabalhista comprometida com a defesa ética e técnica dos direitos do trabalhador.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-[#C9A961] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Áreas de Atuação
            </h4>
            <ul className="space-y-2 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <li><a href="#" className="text-gray-300 hover:text-[#C9A961] transition-colors">Demissão sem Justa Causa</a></li>
              <li><a href="#" className="text-gray-300 hover:text-[#C9A961] transition-colors">Horas Extras</a></li>
              <li><a href="#" className="text-gray-300 hover:text-[#C9A961] transition-colors">Verbas Rescisórias</a></li>
              <li><a href="#" className="text-gray-300 hover:text-[#C9A961] transition-colors">Acidente de Trabalho</a></li>
              <li><a href="#" className="text-gray-300 hover:text-[#C9A961] transition-colors">Assédio Moral</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-[#C9A961] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Contato
            </h4>
            <ul className="space-y-3 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-[#C9A961] text-lg"></i>
                <a href="https://wa.me/5532998566774" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#C9A961] transition-colors">
                  (32) 99856-6774
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#C9A961] text-lg"></i>
                <a href="mailto:Barbaramarcelinoadv@hotmail.com" className="text-gray-300 hover:text-[#C9A961] transition-colors">
                  Barbaramarcelinoadv@hotmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-[#C9A961] text-lg"></i>
                <a href="https://www.instagram.com/barbaramarcelinoadv?igsh=NWFmeHR0bmQ0NmRr&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#C9A961] transition-colors">
                  Instagram
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-map-pin-line text-[#C9A961] text-lg"></i>
                <span className="text-gray-300">Juiz de Fora - MG</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-[#C9A961] text-lg mt-0.5"></i>
                <div>
                  <span className="text-gray-300">Seg. a Sex.: 8h às 18h</span>
                  <p className="text-gray-400 text-xs mt-0.5">Atendimento online em todo Brasil</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          {/* Ethics Notice */}
          <div className="bg-[#5A2C50]/30 rounded-xl p-6 mb-8">
            <h4 className="text-sm font-bold text-[#C9A961] mb-3" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Aviso de Responsabilidade Ética e Profissional
            </h4>
            <p className="text-xs text-gray-300 leading-relaxed mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Este site foi desenvolvido em conformidade com o <strong>Código de Ética e Disciplina da OAB</strong> e o 
              <strong> Provimento nº 205/2021</strong>, que regulamenta a publicidade na advocacia. Todas as informações aqui 
              apresentadas têm caráter meramente informativo e educativo.
            </p>
            <p className="text-xs text-gray-300 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <strong>Não são feitas promessas de resultado.</strong> O êxito em qualquer demanda judicial depende das 
              circunstâncias específicas de cada caso, das provas apresentadas e da interpretação judicial aplicável. 
              A consulta jurídica é essencial para análise individualizada de cada situação.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center text-sm text-gray-400" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            <p>&copy; {currentYear} Barbara Marcelino Claudino - Advocacia e Consultoria Jurídica. Todos os direitos reservados.</p>
            <p className="mt-2 text-xs">OAB/MG - Atuação em conformidade com as normas éticas da advocacia brasileira.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}